import { Attribute, Directive, Injector, forwardRef } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';
import { AppComponentBase } from '@shared/app-component-base';
import * as moment from 'moment';

@Directive({
  selector: '[validateLowerOrEqualThan][ngModel],[validateLowerOrEqualThan][formControl]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => LowerOrEqualThanValidator),
      multi: true
    }
  ]
})
export class LowerOrEqualThanValidator extends AppComponentBase implements Validator {
  constructor(injector: Injector, @Attribute('validateLowerOrEqualThan') public endDate: string) {
    super(injector);
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const startDateControl = control;
    const endDateControl = control.root.get(this.endDate);

    if (!startDateControl || !endDateControl) {
      return null;
    }

    const startDate = moment(startDateControl.value, this.getDateInputFormat(), true);
    const endDate = moment(endDateControl.value, this.getDateInputFormat(), true);

    return startDate.isAfter(endDate, 'day') ? { validateLowerOrEqualThan: true } : null;
  }
}
